export default {
  avatar: {
    title: "Сменить аватар",
  },
  bindRole: {
    allServers: "Все Серверы",
    bindFailed: "Не удалось привязать персонажа",
    bindSuccess: "Персонаж привязан",
    getRoleListFailed: "Не удалось получить список персонажей",
    getServerListFailed: "Не удалось получить список серверов",
    modifyTitle: "Сменить привязанного персонажа",
    noRole: "Персонаж недоступен",
    recentServers: "Ваш Сервер",
    role: "Имя персонажа:",
    rolePlaceholder: "Выбрать персонажа",
    server: "Сервер:",
    serverPlaceholder: "Выбрать сервер",
    title: "Привязать персонажа",
  },
  commentModal: {
    placeholder: "Напишите комментарий...",
    replyTo: "Ответить {username}",
    title: "Комментарий",
  },
  common: {
    cancel: "Отмена",
    confirm: "Принять",
    landscapeTip: "Пожалуйста, поверните телефон в портретный режим для лучшего опыта",
    loadMore: "Потяните вверх, чтобы загрузить больше",
    loading: "Загрузка...",
    loadingMore: "Загрузить больше...",
    noMore: "Больше данных нет",
    refreshFailed: "Сбой обновления",
    refreshSuccess: "Обновлено",
    submit: "Отправить",
    all: "Все",
    language: "Язык",
  },
  error: {
    50002: "Токен недействителен или истёк срок",
    50006: "Это имя занято",
    50007: "Вы можете изменить свой никнейм только один раз в месяц, вы уже изменили его в этом месяце",
    50008: "Недостаточно очков",
    50301: "У вас нет прав для публикации",
    50302: "Лимит публикаций исчерпан",
    50303: "Длина содержимого не соответствует требованиям",
    50304: "Текст содержит недопустимые слова. Измените и повторите попытку.",
    50308: "Недостаточно прав для просмотра этой публикации",
    50309: "Публикация удалена или перемещена",
    50351: "Тема закрыта, ответ невозможен",
    50353: "У вас нет прав для ответа",
    50354: "Ответы запрещены в этом разделе",
    50355: "Слишком частые публикации, повторите позже",
    50356: "Превышен часовой лимит публикаций",
    50361: "Комментарий не найден",
    50500: "Поиск пока недоступен",
    50501: "Поиск отключен",
    50502: "Текст содержит недопустимые слова. Измените и повторите попытку.",
    50505: "Поиск слишком частый, пожалуйста, попробуйте позже",
    50703: "Проверка изображения не пройдена",
    50704: "Изображение не соответствует правилам",
    50214: "Не удалось поделиться: вы не вступили в @:shareModal.alliance.",
    common: "Сбой операции. Повторите попытку позже.",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Вы вошли",
    loginInSuccess: "Вход выполнен",
    pleaseLogin: "Сначала нужно войти.",
    loginNow: "Войти",
    pullToRefresh: "Потяните вниз для обновления",
    releaseToRefresh: "Отпустите для обновления",
    signFailed: "Ошибка входа",
    signIn: "Войти",
    signInFailedTip: "Ошибка входа. Повторите попытку позже.",
    signSuccess: "Вход выполнен",
    goToShop: "Перейти в Центр Баллов",
    sortByLastPost: "Новые комментарии",
    sortByTime: "Новое",
    tags: {
      activity: "Событие",
      chats: "Обсуждение",
      guide: "Руководство",
      recommend: "Рекомендовать",
      news: "Новости",
    },
    unboundRole: "Персонаж не привязан",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "Техническое обслуживание",
    message: "Извините, игровой форум в настоящее время находится на техническом обслуживании. Пожалуйста, попробуйте позже.",
  },
  mentionModal: {
    searchPlaceholder: "Поиск пользователя",
    title: "Выберите пользователя",
  },
  nicknameModify: {
    alreadyRenamed:
      "Сменить имя можно раз в месяц, в этом месяце вы уже меняли его",
    changedNickname: "Изменить имя",
    cost: "Стоимость",
    date: "Дата",
    getMore: "Получить",
    nicknameTooShort: "Имя должно содержать не менее 3 символов",
    coinNotEnough: "Недостаточно очков",
    placeholder: "Введите имя",
    recordTitle: "История изменений",
    sameNickname: "Новое имя не должно совпадать с текущим.",
    success: "Сохранено",
    viewRecord: "История изменений",
  },
  notice: {
    empty: "Сообщений пока нет",
    likeComment: "{username} оценил(а) ваш комментарий",
    likePost: "{username} оценил(а) вашу публикацию",
    mentionComment: "{username} упомянул(а) ваш комментарий",
    mentionPost: "{username} упомянул(а) вашу публикацию",
    replyComment: "{username} ответил(а) на ваш комментарий",
    replyPost: "{username} ответил(а) на вашу публикацию",
    system: "Системное уведомление",
    tabs: {
      like: "Нравится",
      mention: "Упомянул меня",
      notification: "Уведомление",
      reply: "Ответил мне",
    },
    title: "Уведомления о сообщениях",
  },
  operateModal: {
    confirmDelete: "Вы уверены, что хотите удалить эту публикацию?",
    copyFailed: "Не удалось скопировать",
    copyLink: "Скопировать ссылку",
    copySuccess: "Скопировано",
    delete: "Удалить",
    shareToGame: "Поделиться в игре",
    deleteFailed: "Не удалось удалить",
    deleteSuccess: "Удалено!",
    title: "Действие",
  },
  shareModal: {
    selectChannelTitle: "Выберите канал для публикации",
    channelLabel: "Канал",
    channelPlaceholder: "Выберите канал",
    alliance: "Альянс",
    shareSuccess: "Поделились успешно",
    continueBrowse: "Продолжить просмотр",
    goToGame: "Смотреть в игре",
    noThreadTip: "Сначала откройте публикацию",
  },
  post: {
    create: {
      contentEmpty: "Содержимое не может быть пустым",
      contentPlaceholder: "Напишите что-нибудь...",
      failed: "Не удалось опубликовать",
      fileTooLarge: "Файл слишком большой (макс. {maxSize})",
      image: "Изображение",
      imageSizeLimit: "Размер изображения: до 5 МБ",
      imageUploadFailed: "Ошибка загрузки фото",
      imageUploadSuccess: "Фото загружено",
      imageUploading: "Загрузка изображения, подождите...",
      invalidFileType: "Формат не поддерживается",
      maxCharsReached: "Превышен лимит символов ({max} символов)",
      mention: "{'@'}",
      selectBoard: "Выберите раздел",
      topicLabel: "Тема",
      submit: "Публикация",
      submitting: "Публикация...",
      success: "Опубликовано",
      title: "Публикация",
      titleEmpty: "Заголовок не может быть пустым",
      titlePlaceholder: "Введите заголовок",
      video: "Видео",
      videoSizeLimit: "Размер видео: до 50 МБ",
      videoUploadFailed: "Ошибка загрузки видео",
      videoUploadSuccess: "Видео загружено",
      videoUploading: "Загрузка видео, подождите...",
    },
    title: "Публикация",
  },
  postDetail: {
    allComments: "Все {num} ответов",
    allReplies: "Ответить всем",
    author: "Автор",
    cancelFavorite: "Удалено из избранного",
    commentTooShort: "Комментарий должен быть не менее 5 символов.",
    translate: "Перевести",
    translating: "Переводится...",
    translateSuccess: "Перевод выполнен успешно",
    translateFailed: "Ошибка перевода",
    translatedTo: "Переведено на",
    earliest: "Самый ранний ответ",
    favoriteSuccess: "Добавлено в избранное",
    floor: "Floor",
    latest: "Последний ответ",
    loadFailed: "Ошибка загрузки",
    noContent: "Нет контента",
    onlyAuthor: "Только автору",
    reply: "Ответить",
    replyTo: "Ответить",
    sendFailed: "Ошибка отправки",
    sendSuccess: "Отправлено",
    sending: "Отправка...",
    viewOriginalPost: "Оригинальная публикация",
    writeSomething: "Что-то пишет...",
  },
  profile: {
    addLikeSuccess: "Нравится",
    cancelLikeSuccess: "Не нравится",
    communityId: "ID сообщества",
    editNickname: "Изменить имя",
    followSuccess: "Подписан",
    followed: "Подписки",
    followers: "Подписчики",
    follow: "Подписаться",
    likes: "Оценки",
    noFavorites: "Нет избранного",
    noPosts: "Нет обновлений",
    shopLabel: "Магазин баллов",
    tabs: {
      favorites: "Избранное",
      posts: "Обновления",
    },
    title: "Профиль",
    unfollowSuccess: "Не подписан",
  },
  search: {
    btn: "Поиск",
    empty: "Контент отсутствует",
    filter: {
      dateline: "Новое",
      title: "Фильтр",
      views: "Популярное",
    },
    historyTitle: "История поиска",
    hotTitle: "Популярное",
    relatedPosts: "Похожие записи",
    tabs: {
      post: "Публикация",
      user: "Пользователь",
    },
  },
  setting: {
    about: "О нас",
    logout: "Выход",
    logoutSuccess: "Вы вышли",
    privacy: "Политика конфиденциальности",
    service: "Пользовательское соглашение",
    title: "Настройки",
  },
  shop: {
    emptyTip: "Магазин в разработке. Следите за обновлениями!",
    record: "История обменов",
    title: "Центр обмена",
    bindRole: "Привязка Персонажа",
    switchRole: "Смена Персонажа",
    tabs: {
      tasks: "Задания",
      rewards: "Обмен наград",
    },
    taskInProgress: "В процессе",
    taskCompleted: "Завершено",
    goToComplete: "Задание",
    exchange: "Обменять",
    exchanged: "Обменено",
    exchangeConfirmTitle: "Подтвердить обмен?",
    currentCoins: "Текущие очки",
    costCoins: "Очки к списанию",
    receiveRole: "Персонаж получатель",
    exchangeSuccess: "Обмен успешен",
    exchangeFailed: "Обмен не удался",
  },
  exchangeRecord: {
    time: "Время",
    content: "Содержимое",
    points: "Очки",
    empty: "Нет записей об обмене",
  },
  tabBar: {
    home: "Главная",
    notice: "Сообщения",
    profile: "Профиль",
  },
  time: {
    hoursAgo: "{hours} ч. назад",
    minutesAgo: "{minutes} мин. назад",
  },
};
